import { useState } from "react";
import CoursesList from "./_components/CoursesList";
import EnrollmentProcess from "./_components/EnrollmentProcess";
import { useLanguage } from "../../../context/LanguageContext";
import { UserCoursesData } from "../../../lib/languages";

export default function CoursesPage() {
  const { language } = useLanguage();
  const t = UserCoursesData[language] || UserCoursesData.en;

  const [selectedCourse, setSelectedCourse] = useState(null);
  const [showEnrollment, setShowEnrollment] = useState(
    !!localStorage.getItem("ShowEnrollment")
  );

  const handleCourseSelect = (course) => {
    setSelectedCourse(course);
    setShowEnrollment(true);
    localStorage.setItem("ShowEnrollment", "true");
    localStorage.setItem("course", JSON.stringify(course));
  };

  const handleBackToList = () => {
    [
      "ShowEnrollment",
      "course",
      "CurrentStep",
      "SelectedDate",
      "SelectedLevel",
      "SelectedPrice",
      "SelectedSlots",
      "SelectedTeacher",
    ].forEach((key) => localStorage.removeItem(key));
  };

  return (
    <div className="space-y-6" dir={language === "ar" ? "rtl" : "ltr"}>
      {!showEnrollment ? (
        <>
          <h1 className="text-2xl font-bold mb-8">{t.availableCourses}</h1>
          <CoursesList onSelectCourse={handleCourseSelect} />
        </>
      ) : (
        <EnrollmentProcess
          course={JSON.parse(localStorage.getItem("course")) || selectedCourse}
          onBackToList={handleBackToList}
          setShowEnrollment={setShowEnrollment}
        />
      )}
    </div>
  );
}

